// India Pin Code → coordinates mapping (offline, bundled)
// Covers top metro / tier-1 / tier-2 cities. For unknown pins we fall back to state-centroid.
// Source: aggregated from India Post (PINCode = first 6 digits) — public dataset.
// Format: { pinPrefix3: { lat, lng, city, state } } — first 3 digits drive region.
// (3-digit prefix is the postal sub-region, sufficient for visualisation.)

export const PIN_PREFIX_COORDS = {
  // Maharashtra
  "400": { lat: 19.0760, lng: 72.8777, city: "Mumbai", state: "Maharashtra" },
  "411": { lat: 18.5204, lng: 73.8567, city: "Pune", state: "Maharashtra" },
  "440": { lat: 21.1458, lng: 79.0882, city: "Nagpur", state: "Maharashtra" },
  "431": { lat: 19.8762, lng: 75.3433, city: "Aurangabad", state: "Maharashtra" },
  "422": { lat: 19.9975, lng: 73.7898, city: "Nashik", state: "Maharashtra" },
  // Karnataka
  "560": { lat: 12.9716, lng: 77.5946, city: "Bangalore", state: "Karnataka" },
  "570": { lat: 12.2958, lng: 76.6394, city: "Mysuru", state: "Karnataka" },
  "580": { lat: 15.3647, lng: 75.1240, city: "Hubballi", state: "Karnataka" },
  "575": { lat: 12.9141, lng: 74.8560, city: "Mangaluru", state: "Karnataka" },
  // Tamil Nadu
  "600": { lat: 13.0827, lng: 80.2707, city: "Chennai", state: "Tamil Nadu" },
  "641": { lat: 11.0168, lng: 76.9558, city: "Coimbatore", state: "Tamil Nadu" },
  "625": { lat: 9.9252,  lng: 78.1198, city: "Madurai",   state: "Tamil Nadu" },
  "620": { lat: 10.7905, lng: 78.7047, city: "Tiruchirappalli", state: "Tamil Nadu" },
  // Delhi NCR
  "110": { lat: 28.6139, lng: 77.2090, city: "New Delhi", state: "Delhi" },
  "201": { lat: 28.5355, lng: 77.3910, city: "Noida",     state: "Uttar Pradesh" },
  "122": { lat: 28.4595, lng: 77.0266, city: "Gurugram",  state: "Haryana" },
  "121": { lat: 28.4089, lng: 77.3178, city: "Faridabad", state: "Haryana" },
  // Telangana / Andhra
  "500": { lat: 17.3850, lng: 78.4867, city: "Hyderabad", state: "Telangana" },
  "501": { lat: 17.3850, lng: 78.4867, city: "Hyderabad", state: "Telangana" },
  "520": { lat: 16.5062, lng: 80.6480, city: "Vijayawada", state: "Andhra Pradesh" },
  "530": { lat: 17.6868, lng: 83.2185, city: "Visakhapatnam", state: "Andhra Pradesh" },
  // West Bengal
  "700": { lat: 22.5726, lng: 88.3639, city: "Kolkata", state: "West Bengal" },
  "713": { lat: 23.5380, lng: 87.2900, city: "Durgapur", state: "West Bengal" },
  // Gujarat
  "380": { lat: 23.0225, lng: 72.5714, city: "Ahmedabad", state: "Gujarat" },
  "390": { lat: 22.3072, lng: 73.1812, city: "Vadodara",  state: "Gujarat" },
  "395": { lat: 21.1702, lng: 72.8311, city: "Surat",     state: "Gujarat" },
  "360": { lat: 22.3039, lng: 70.8022, city: "Rajkot",    state: "Gujarat" },
  // Rajasthan
  "302": { lat: 26.9124, lng: 75.7873, city: "Jaipur",  state: "Rajasthan" },
  "342": { lat: 26.2389, lng: 73.0243, city: "Jodhpur", state: "Rajasthan" },
  "313": { lat: 24.5854, lng: 73.7125, city: "Udaipur", state: "Rajasthan" },
  "324": { lat: 25.2138, lng: 75.8648, city: "Kota",    state: "Rajasthan" },
  // Uttar Pradesh
  "226": { lat: 26.8467, lng: 80.9462, city: "Lucknow",  state: "Uttar Pradesh" },
  "208": { lat: 26.4499, lng: 80.3319, city: "Kanpur",   state: "Uttar Pradesh" },
  "282": { lat: 27.1767, lng: 78.0081, city: "Agra",     state: "Uttar Pradesh" },
  "221": { lat: 25.3176, lng: 82.9739, city: "Varanasi", state: "Uttar Pradesh" },
  "250": { lat: 28.9845, lng: 77.7064, city: "Meerut",   state: "Uttar Pradesh" },
  // Madhya Pradesh
  "452": { lat: 22.7196, lng: 75.8577, city: "Indore",   state: "Madhya Pradesh" },
  "462": { lat: 23.2599, lng: 77.4126, city: "Bhopal",   state: "Madhya Pradesh" },
  "474": { lat: 26.2183, lng: 78.1828, city: "Gwalior",  state: "Madhya Pradesh" },
  "482": { lat: 23.1815, lng: 79.9864, city: "Jabalpur", state: "Madhya Pradesh" },
  // Bihar
  "800": { lat: 25.5941, lng: 85.1376, city: "Patna",       state: "Bihar" },
  "823": { lat: 24.7914, lng: 84.9994, city: "Gaya",        state: "Bihar" },
  // Punjab / Haryana / Chandigarh
  "143": { lat: 31.6340, lng: 74.8723, city: "Amritsar",  state: "Punjab" },
  "141": { lat: 30.9010, lng: 75.8573, city: "Ludhiana",  state: "Punjab" },
  "144": { lat: 31.3260, lng: 75.5762, city: "Jalandhar", state: "Punjab" },
  "160": { lat: 30.7333, lng: 76.7794, city: "Chandigarh", state: "Chandigarh" },
  "125": { lat: 29.1492, lng: 75.7217, city: "Hisar",     state: "Haryana" },
  // Kerala
  "682": { lat: 9.9312,  lng: 76.2673, city: "Kochi",            state: "Kerala" },
  "695": { lat: 8.5241,  lng: 76.9366, city: "Thiruvananthapuram", state: "Kerala" },
  "673": { lat: 11.2588, lng: 75.7804, city: "Kozhikode",        state: "Kerala" },
  // Odisha
  "751": { lat: 20.2961, lng: 85.8245, city: "Bhubaneswar", state: "Odisha" },
  "753": { lat: 20.4625, lng: 85.8830, city: "Cuttack",     state: "Odisha" },
  // Assam / NE
  "781": { lat: 26.1445, lng: 91.7362, city: "Guwahati", state: "Assam" },
  // Jharkhand
  "834": { lat: 23.3441, lng: 85.3096, city: "Ranchi",     state: "Jharkhand" },
  "831": { lat: 22.8046, lng: 86.2029, city: "Jamshedpur", state: "Jharkhand" },
  // Chhattisgarh
  "492": { lat: 21.2514, lng: 81.6296, city: "Raipur", state: "Chhattisgarh" },
  // Uttarakhand
  "248": { lat: 30.3165, lng: 78.0322, city: "Dehradun", state: "Uttarakhand" },
  // Himachal
  "171": { lat: 31.1048, lng: 77.1734, city: "Shimla", state: "Himachal Pradesh" },
  // J&K
  "180": { lat: 32.7266, lng: 74.8570, city: "Jammu",   state: "Jammu and Kashmir" },
  "190": { lat: 34.0837, lng: 74.7973, city: "Srinagar", state: "Jammu and Kashmir" },
  // Goa
  "403": { lat: 15.2993, lng: 74.1240, city: "Panaji", state: "Goa" },
};

// State-level centroids (fallback when pin prefix isn't in the table above)
export const STATE_CENTROIDS = {
  "Maharashtra":      { lat: 19.7515, lng: 75.7139 },
  "Karnataka":        { lat: 15.3173, lng: 75.7139 },
  "Tamil Nadu":       { lat: 11.1271, lng: 78.6569 },
  "Delhi":            { lat: 28.7041, lng: 77.1025 },
  "Telangana":        { lat: 18.1124, lng: 79.0193 },
  "Andhra Pradesh":   { lat: 15.9129, lng: 79.7400 },
  "West Bengal":      { lat: 22.9868, lng: 87.8550 },
  "Gujarat":          { lat: 22.2587, lng: 71.1924 },
  "Rajasthan":        { lat: 27.0238, lng: 74.2179 },
  "Uttar Pradesh":    { lat: 26.8467, lng: 80.9462 },
  "Madhya Pradesh":   { lat: 22.9734, lng: 78.6569 },
  "Bihar":            { lat: 25.0961, lng: 85.3131 },
  "Punjab":           { lat: 31.1471, lng: 75.3412 },
  "Haryana":          { lat: 29.0588, lng: 76.0856 },
  "Kerala":           { lat: 10.8505, lng: 76.2711 },
  "Odisha":           { lat: 20.9517, lng: 85.0985 },
  "Assam":            { lat: 26.2006, lng: 92.9376 },
  "Jharkhand":        { lat: 23.6102, lng: 85.2799 },
  "Chhattisgarh":     { lat: 21.2787, lng: 81.8661 },
  "Uttarakhand":      { lat: 30.0668, lng: 79.0193 },
  "Himachal Pradesh": { lat: 31.1048, lng: 77.1734 },
  "Goa":              { lat: 15.2993, lng: 74.1240 },
  "Chandigarh":       { lat: 30.7333, lng: 76.7794 },
  "Jammu and Kashmir":{ lat: 33.7782, lng: 76.5762 },
};

/** Resolve a pin code (6 digits) to {lat, lng, city, state}. Falls back to state centroid. */
export function pinCodeToLatLng(pinCode, fallbackState) {
  if (pinCode && pinCode.length >= 3) {
    const prefix = pinCode.toString().slice(0, 3);
    const hit = PIN_PREFIX_COORDS[prefix];
    if (hit) return hit;
  }
  if (fallbackState && STATE_CENTROIDS[fallbackState]) {
    return { ...STATE_CENTROIDS[fallbackState], city: fallbackState, state: fallbackState };
  }
  return null;
}
